
function getSystemPrompt() {
return `
You are a professional fitness consultant.  
`;
}

function generateUserPrompt(brand, model) {
return `
Please tell me the bar weight of the Smith machine with the brand and model listed below, and include the source of the information. If the information is not available, just let me know it couldn’t be found. Please do not fabricate any data.
Brand: ${brand} 
Model: ${model} 

🌟 Important: Output clean HTML only. Do not use Markdown code fences (no \`\`\`). Only use valid HTML tags such as <h2>, <ul>, <li>, <p>, <a>, and emojis where appropriate to keep the tone upbeat and supportive. 

`;
}

const submitBtn = document.getElementById("submit-btn");
if (submitBtn) {
submitBtn.addEventListener("click", async function () {

    const brand = document.getElementById('brand').value;
    const model = document.getElementById('model').value;
    const responseDiv = document.getElementById('response'); 

    if (!brand || !model) {
    responseDiv.innerHTML = "❗ Please fill in all fields.";
    return;
    }

    responseDiv.innerHTML = "🤖 I’m Vanswe Smart Coach Max. Please hold on while I search the database based on the brand and model you provided. This usually takes about 2–8 seconds.<span class='cursor'>|</span>";

    const messages = [
    {
        role: "system",
        content: getSystemPrompt()
    },
    {
        role: "user",
        content: generateUserPrompt(brand,model)
    }
    ];

    try {
      const res = await fetch("https://api.deepseek.com/v1/chat/completions", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + "sk-568aa543d48a465b88e97f25a07a48c0"
        },
        body: JSON.stringify({
          model: "deepseek-chat",
          temperature: 0.8,
          top_p: 0.9,
          max_tokens: 2000,
          messages: messages,
          stream: true  // 添加流式传输
        })
      });

      // 检查响应状态
      if (!res.ok) {
        throw new Error(`API request failed with status ${res.status}`);
      }

      const reader = res.body.getReader();
      const decoder = new TextDecoder("utf-8");
      let buffer = "";
      let finalHTML = "";

      while (true) {
        const { value, done } = await reader.read();
        if (done) break;

        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split("\n");
        buffer = lines.pop();

        for (let line of lines) {
          if (line.startsWith("data: ")) {
            const jsonStr = line.replace("data: ", "").trim();
            if (jsonStr === "[DONE]") continue;

            try {
              const parsed = JSON.parse(jsonStr);
              // 修正为 DeepSeek 的响应格式
              const chunk = parsed.choices?.[0]?.delta?.content || "";
              if (chunk) {
                finalHTML += chunk;
                responseDiv.innerHTML = finalHTML + `<span class="cursor">|</span>`;
              }
            } catch (e) {
              console.warn("Failed to parse line:", jsonStr);
            }
          }
        }
      }


      responseDiv.innerHTML = finalHTML;
      finalHTML += `
      <h2>🛒 Looking For A Home Gym Smith Machine?</h2>
      <div style="display: flex; gap: 20px; flex-wrap: wrap; justify-content: center; margin-top: 24px;">
      <div style="text-align: center; width: 240px;">
        <img src="https://cdn.shopify.com/s/files/1/0004/0779/7826/files/CompactSmithMachineMainImage_3_240x240.jpg?v=1735619058" alt="compact smith machine" style="margin-bottom: 8px;">
        <a href="https://www.vanswefitness.com/products/compact-smith-machine" target="_blank">Vanswe Compact Home Gym Smith Machine</a>
        </div>

        <div style="text-align: center; width: 240px;">
        <img src="https://cdn.shopify.com/s/files/1/0004/0779/7826/files/SmithMachineMainImage_4_240x240.jpg?v=1735618912" alt="home gym smith machine" style="margin-bottom: 8px;">
        <a href="https://www.vanswefitness.com/products/smith-machine" target="_blank">Vanswe All-in-one Home Gym Smith Machine</a>
        </div>
      </div>
        `;

      // Re-render with final content and recommendations
      responseDiv.innerHTML = finalHTML;
    } catch (err) {
      console.error("AI stream error:", err);
      responseDiv.innerHTML = "❌ An error occurred. Please try again later.";
    }
  });
}


// 引入 html2canvas 脚本
const script = document.createElement("script");
script.src = "https://cdn.jsdelivr.net/npm/html2canvas@1.4.1/dist/html2canvas.min.js";
script.onload = () => {
const button = document.getElementById("generate-image");
const result = document.getElementById("response");

if (button && result) {
    button.addEventListener("click", () => {
    html2canvas(result, {
        scale: 2,
        useCORS: true
    }).then(canvas => {
        const link = document.createElement("a");
        link.download = "bmi-result.png";
        link.href = canvas.toDataURL("image/png");
        link.click();
    });
    });
}
};
document.body.appendChild(script);

const copyBtn = document.getElementById("copy-report");

if (copyBtn) {
copyBtn.addEventListener("click", () => {
    const responseEl = document.getElementById("response");

    if (!responseEl || responseEl.innerHTML.trim() === "") {
    alert("❗ the result has not been generated yet. Nothing to copy.");
    return;
    }

    const htmlContent = responseEl.innerHTML;
    const textContent = responseEl.innerText;

    const blobHTML = new Blob([htmlContent], { type: "text/html" });
    const blobText = new Blob([textContent], { type: "text/plain" });

    const data = [new ClipboardItem({
    "text/html": blobHTML,
    "text/plain": blobText
    })];

    navigator.clipboard.write(data)
    .then(() => {
        alert("✅ Your result has been copied!");
    })
    .catch(err => {
        console.error("Clipboard copy failed:", err);
        alert("❌ Copy failed. Please copy manually.");
    });
});
}